<template>
  <table ref="virtualTable">
    <slot></slot>
    <div v-bind:is="template" v-for="(item, itemIndex) of visibleChildren" :key="`virtual-item-${itemIndex}`" :item="item"></div>
  </table>
</template>

<script>
  export default {
    name: "VirtualList",
    data() {
      return {
        children: [],
        index: 100,
        observer: null
      };
    },
    props: {
      items: Array,
      template: Object
    },
    watch: {
      items() {
        this.index = 100;
        setTimeout(() => {
          this.rebindObserver();
        }, 1)
      }
    },
    mounted() {
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          let children = this.$refs.virtualTable.children;
          this.observer.unobserve(children[children.length - 1]);
          this.index += 100;
          if (this.index < this.items.length) {
            setTimeout(() => {
              this.rebindObserver();
            }, 1);
          }
        }
      });
      this.rebindObserver();
    },
    computed: {
      visibleChildren() {
        if (this.items.length < this.index) {
          return this.items;
        }
        return [...this.items.slice(0, this.index)];
      }
    },
    methods: {
      rebindObserver() {
        this.observer.disconnect();
        let children = this.$refs.virtualTable.children;
        let child = children[children.length - 1];
        this.observer.observe(child);
      }
    }
  }
</script>